import { $, _ } from 'wgnet-awesomejs';

export default function initTooltip(container) {
    const isMT = _.extract('Settings.Registration.gameModificator') === 'wot';
    const mobileResolutionTriggerSize = 500;
    const el = $(container);
    if (el.length === 0) {
        return null;
    }
    const calcLeft = (tooltip) => {
        let left;
        const isRtlLang = _.extract('Settings.cssDirection') === 'rtl';
        if ($(window).width() < mobileResolutionTriggerSize) {
            if (isRtlLang) {
                const right = (tooltip.offset().left + (2 * tooltip.width())) - window.innerWidth;
                return { right };
            }
            left = -tooltip.offset().left;
        }
        return { left };
    };
    const closeTooltip = () => {
        $('.js-tooltip').each(function fn() {
            const $tooltip = $(this);
            const openClass = $tooltip.data('open-class');
            if (openClass) {
                $tooltip.removeClass(openClass);
            }
            const wrapper = $('.js-tooltip-wrapper', $tooltip);
            wrapper.css({ left: '', right: '' });
        });
    };
    el.on('click', '.js-tooltip', (event) => {
        const tooltip = $(event.currentTarget);
        if (!isMT) {
            const wrapper = $('.js-tooltip-wrapper', tooltip);
            wrapper.css(calcLeft(tooltip));
        }
        tooltip.addClass(tooltip.data('open-class'));
        return false;
    });
    el.on('click', '.js-tooltip-close', (event) => {
        const tooltip = $(event.currentTarget).parents('.js-tooltip')[0];
        const openClass = tooltip.getAttribute('data-open-class');
        tooltip.classList.remove(openClass);
        const wrapper = $('.js-tooltip-wrapper', tooltip);
        wrapper.css({ left: '', right: '' });
        event.stopPropagation();
        return false;
    });
    $('body').on('click', ':not(.js-tooltip)', () => {
        closeTooltip();
    });
    $(window).resize(() => {
        closeTooltip();
    });
    $(window).on('orientationchange', () => {
        closeTooltip();
    });
    return el;
}



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/base/tooltip.js